import React from 'react'
import { useSelector } from 'react-redux';

function PayableTo() {
    const ClaimData = useSelector((state)=> state.claimDetailSlice);


  return (
    <div>    <div class="intro-y box mt-lg-5">
    <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
        <h2 class="fw-medium fs-base me-auto">
            Payable To
        </h2>
    </div>
    <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
         <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
             <div class="d-flex flex-column  mt-3">
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> PayableTo : <div class="text-gray-600 text-wrap px-2">{ClaimData.payabletTo.payabletTo} </div></div>
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Payee City : <div class="text-gray-600 px-2">{ClaimData.payabletTo.city}</div></div>
            </div>
        </div>
            <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
            <div class="d-flex flex-column  mt-3">
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Payee Address : <div class="text-gray-600 px-2"> {ClaimData.payabletTo.address}</div> </div>
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Payee ZIP : <div class="text-gray-600 px-2">{ClaimData.payabletTo.zipcode}</div></div>  
            </div>
        </div>
        <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
            <div class="d-flex flex-column  mt-3">
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Payee State : <div class="text-gray-600 px-2">{ClaimData.payabletTo.state}</div></div>
                <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Payment Type : <div class="text-gray-600 px-2">{ClaimData.payabletTo.paymentType}</div></div>  

           </div>
       </div>
    </div>
</div></div>
  )
}

export default PayableTo